<template>
  <div v-if="isScanner"
       class="w-full flex" style="height:75vh; min-height:400px;">
    <div class="grid m-auto" style="text-align: center;">
      <h5 class="mb-4">사무소명 : {{ projectInfo.field_name }}</h5>
      <vs-button class="mt-2" type="border" color="secondary" @click="handleQrScanner">
        <span style="display: flex; align-items: center; justify-content: center; line-height: 5">
          <feather-icon class="mr-2" icon="CameraIcon"/> QR 코드 스캔
        </span>
      </vs-button>
      <vs-button class="mt-2" type="border" color="secondary" @click="handleInputCheckManagerLog">
        <span style="display: flex; align-items: center; justify-content: center; line-height: 5">
          <feather-icon class="mr-2" icon="SearchIcon"/> 출역 기록 및 통계
        </span>
      </vs-button>
    </div>

  </div>
  <div v-else
       class="w-full flex" style="height:75vh; min-height:400px;">
    <div class="grid m-auto" style="text-align: center;">
      <h5 class="mb-4">사무소명 : {{ projectInfo.field_name }}</h5>
      <vue-q-r-code-component class="mb-2"
                              :text="qrCodeContent"
                              :size="180"
                              error-level="L"
      ></vue-q-r-code-component>
      <div class="mb-8" style="display: flex; align-items: center; justify-content: center;">
        <feather-icon icon="ClockIcon" class="mr-1" />
        남은시간 : {{count}}초
      </div>
      <vs-button type="border" color="secondary" @click="handleInputCheckLog">출역 체크 기록 확인</vs-button>
    </div>
  </div>
</template>

<script>
import config from '/public/config'
import VueQRCodeComponent from 'vue-qrcode-component'
export default {
  name: 'InputCheck',
  components: {
    VueQRCodeComponent
  },
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    },

    qrCodeContent () {
      return this.$store.state.auth.qrCodeContent
    },

    isScanner () {
      return this.$store.state.auth.isScanner
    }
  },
  mounted () {
    this.createQrCode()
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  data () {
    return {
      baseUrl:config.BASE_URL,
      count:15,
      timer:null
    }
  },

  methods:{
    async createQrCode () {
      const projectId = this.projectInfo.id
      if (projectId) {

        await this.$store.dispatch('IS_QR_SCAN_MANAGER', {projectId})

        const isScanner = this.$store.state.auth.isScanner
        if (isScanner) {

        } else {
          await this.$store.dispatch('LOAD_CHECK_QR', {projectId})
          this.startCountDown()
        }
      }
    },

    handleInputCheckLog () {
      this.$router.push(`/m/project/${this.projectInfo.id}/input-check-log`)
    },
    handleInputCheckManagerLog () {
      this.$router.push(`/m/project/${this.projectInfo.id}/input-check-log`)
    },
    handleQrScanner () {
      const projectId = this.projectInfo.id
      const userId = this.$store.state.auth.userInfo.id
      const userToken = this.$store.state.auth.userToken
      if (window.QrScanner && window.QrScanner.postMessage) {
        window.QrScanner.postMessage(JSON.stringify({
          command:'open',
          projectId,
          userId,
          userToken
        }))
      }
    },
    startCountDown () {
      this.count = 15
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.countDown()
      }, 1000)
    },
    countDown () {
      if (this.count === 0) {
        this.createQrCode()
      } else {
        this.count--

        this.timer = setTimeout(() => {
          this.countDown()
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>

</style>
